import { useState } from 'react';

export interface CreateProjectFormData {
  name: string;
  address: string;
  startDate: string;
  endDate: string;
  paymentMethod: string;
  hasConstructionTracking: boolean;
  hasAdhocTracking: boolean;
  internalNotes: string;
}

export interface CreateProjectValidationErrors {
  name?: string;
  address?: string;
  startDate?: string;
  endDate?: string;
  paymentMethod?: string;
  internalNotes?: string;
  general?: string;
}

export function useCreateProjectValidation() {
  const [errors, setErrors] = useState<CreateProjectValidationErrors>({});

  const validate = (formData: CreateProjectFormData): boolean => {
    const newErrors: CreateProjectValidationErrors = {};

    // Name validation (required)
    if (!formData.name.trim()) {
      newErrors.name = 'Nome do projeto é obrigatório';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Nome deve ter pelo menos 2 caracteres';
    }

    // Payment method validation (required)
    if (!formData.paymentMethod.trim()) {
      newErrors.paymentMethod = 'Método de pagamento é obrigatório';
    }

    // Date validation
    if (formData.startDate && formData.endDate) {
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);

      if (startDate >= endDate) {
        newErrors.endDate = 'Data de término deve ser posterior à data de início';
      }
    }

    // Address validation (optional but if provided, should be reasonable length)
    if (formData.address && formData.address.length > 500) {
      newErrors.address = 'Endereço deve ter no máximo 500 caracteres';
    }

    // Internal notes validation (optional)
    if (formData.internalNotes && formData.internalNotes.length > 1000) {
      newErrors.internalNotes = 'Notas internas devem ter no máximo 1000 caracteres';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearErrors = () => {
    setErrors({});
  };

  const setError = (field: keyof CreateProjectValidationErrors, message: string) => {
    setErrors(prev => ({ ...prev, [field]: message }));
  };

  return {
    errors,
    validate,
    clearErrors,
    setError,
  };
}